import { mpEventInfo } from '@/constant'
import type { SchoolGrade, Student } from '@/dto'
import type { DefaultResponse } from '@/types'
import maxios from '@/utils/axios/maxios'

// 출석 API
const attendanceApi = {
  // 학생 입실하기
  putAttendanceEnter: (data: req.AttendanceEnter) => {
    return maxios.put<DefaultResponse<res.Attendance[]>>('attendances/enter', data, {
      params: { mp_event_name: mpEventInfo.학생입실등록 },
    })
  },
  // 학생 퇴실하기
  putAttendanceQuit: (data: req.AttendanceQuit) => {
    return maxios.put<DefaultResponse<res.Attendance[]>>('attendances/quit', data, {
      params: { mp_event_name: mpEventInfo.학생퇴실등록 },
    })
  },
  // 가긴에 포함된 출결 가져오기
  getAttendances: (params: req.AttendanceParams) => {
    return maxios.get<DefaultResponse<res.DateAttendanceList[]>>('/attendances', {
      params: { ...params, mp_event_name: mpEventInfo.출결조회 },
    })
  },

  getAttendancesByGrade: (
    schoolType: SchoolGrade['schoolType'],
    grade: SchoolGrade['grade'],
    params: req.AttendanceParams,
  ) => {
    return maxios.get<DefaultResponse<res.DateAttendanceList[]>>(
      `/attendances/grade/${schoolType}/${grade}`,
      {
        params: { ...params, mp_event_name: mpEventInfo.출결조회 },
      },
    )
  },

  getAttendancesByLessonClass: (lessonClassId: number, params: req.AttendanceParams) => {
    return maxios.get<DefaultResponse<res.DateAttendanceList[]>>(
      `/attendances/lesson-class/${lessonClassId}`,
      {
        params: { ...params, mp_event_name: mpEventInfo.출결조회 },
      },
    )
  },

  getAttendancesByStudent: (studentId: Student['id'], params: req.AttendanceParams) => {
    return maxios.get<DefaultResponse<res.DateAttendanceList[]>>(
      `/attendances/student/${studentId}`,
      {
        params: { ...params, mp_event_name: mpEventInfo.출결조회 },
      },
    )
  },

  // 기간에 포함된 출결 내역 다운로드
  getXLS: (params: req.AttendanceXLSParams) => {
    return maxios.get<Blob>('/attendances/xls', {
      responseType: 'blob',
      params: { ...params, mp_event_name: mpEventInfo.출결다운로드 },
    })
  },
  // 학생 입/퇴실 삭제하기
  deleteAttendances: (data: res.Attendance['id'][]) => {
    return maxios({
      url: '/attendances',
      method: 'DELETE',
      data,
      params: { mp_event_name: mpEventInfo.출결삭제 },
    })
  },
}

export default attendanceApi
